<template>
	<Timeline :value="processItems" align="right">
		<template #marker="slotProps">
			<span :style="slotProps.item.active ? 'opacity: 1' : 'opacity: 0.5'">
				<i :class="slotProps.item.icon"></i>
			</span>
		</template>
		<template #content="slotProps">
			<div :style="slotProps.item.active ? 'opacity: 1' : 'opacity: 0.5'">
				{{slotProps.item.status}}
			</div>
		</template>
	</Timeline>
</template>

<script lang="ts">
import {defineComponent} from 'vue';
import Timeline from 'primevue/timeline';

export default defineComponent({
	name: "ProcessTimeline",
	components: {
		Timeline,
	},
	props: {
		processItems: {
			type: Array,
		},
	},
	setup() {
		return {}
	},
})
</script>

<style scoped>
</style>


